import { observer } from 'mobx-react';
import * as React from 'react';
import { classes, style } from 'typestyle';
import { Component, deps, inject } from '../../../lib/component';
import { TrackSchema } from '../../../types/schema';
import PlayButton from './button/PlayButton';
import { colorDisabledImage, rebrand } from '../../../theme/color';
import { NewTrackBadge } from './NewTrackBadge';
import { centerCenter, flexRoot } from 'csstips';
import { NewTrackBadgeTooltip } from './NewTrackBadgeTooltip';

const styles = {
  container: style(flexRoot, centerCenter, {
    position: 'relative',
    overflow: 'hidden',
    backgroundColor: rebrand.neutralOnDark[10].toString(),
    height: '70px',
    width: '70px',
  }),
  rounded: style({
    borderRadius: '4px',
  }),
  containerSmall: style({
    height: '56px',
    width: '56px',
  }),
  trackUnavailable: style({
    position: 'relative',
    display: 'flex',
    $nest: {
      '&::before': {
        content: '""',
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        background: colorDisabledImage.toString(),
        zIndex: 1,
      },
    },
  }),
  image: style({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  }),
  playButton: style({
    zIndex: 2,
    position: 'static',
    $nest: {
      '&::before': {
        content: "''",
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 1,
      },
    },
  }),
  hideWhenNotPlaying: style({
    opacity: 0,
  }),
  badge: style({
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 1,
  }),
  badgeTooltip: style({
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 3,
  }),
};

export interface ImageWithPlayBtnProps {
  track: TrackSchema;
  small?: boolean;
  playButtonClassName?: string;
  trackImageClassname?: string;
  hasImgRadius?: boolean;
  newTrackBadge?: boolean;
  hidePlayBtn?: boolean;
}

@observer
@inject(deps)
export class ImageWithPlayBtn extends Component<ImageWithPlayBtnProps> {
  render() {
    const {
      track,
      small,
      trackImageClassname,
      playButtonClassName,
      hasImgRadius,
      newTrackBadge,
      hidePlayBtn = false,
      model: {
        image: { cover },
      },
    } = this.props;
    const trackIsavailable = track.is_available_in_territory === null ? true : track.is_available_in_territory;

    return (
      <div
        className={classes(
          styles.container,
          hasImgRadius && styles.rounded,
          small && styles.containerSmall,
          !trackIsavailable ? styles.trackUnavailable : '',
          trackImageClassname
        )}
      >
        {track.images && (
          <img
            src={cover(track.images.identity)}
            className={classes(styles.image)}
            loading="lazy"
            decoding="async"
            alt={`Artwork for ${track.title}`}
          />
        )}
        {trackIsavailable && (
          <PlayButton
            className={classes(styles.playButton, hidePlayBtn && styles.hideWhenNotPlaying, playButtonClassName)}
            track={track}
          />
        )}

        {track.is_newly_activated && newTrackBadge && (
          <div className={styles.badge}>
            <NewTrackBadge />
          </div>
        )}

        {track.is_newly_activated && newTrackBadge && (
          <div className={styles.badgeTooltip}>
            <NewTrackBadgeTooltip />
          </div>
        )}
      </div>
    );
  }
}
